import { api } from "./axios-instance";
import { NAVIGATION_LOGS } from "./constants";

const SESSION_KEY = 'session_id';

const getSessionId = () => {
  let session = sessionStorage.getItem(SESSION_KEY);

  if (!session) {
    session = crypto.randomUUID();
    sessionStorage.setItem(SESSION_KEY, session);
  }

  return session;
};

// Fire-and-forget: a navegação não espera pelo registo do log.
export const trackPageView = (page: string, duration?: number) => {
  void api
    .post(NAVIGATION_LOGS, {
      type: 'NAVIGATION',
      action: 'PAGE_VIEW',
      page,
      duration,
      sessionId: getSessionId(),
      userAgent: navigator.userAgent,
      timestamp: new Date().toISOString(),
    })
    .catch(() => {
      console.warn('tracking failed');
    });
};